<template>
  <div v-if="aboutUsPage">
    <banner-part
      :banner-heading="_T_DB(aboutUsPage, 'banner_heading')"
      :banner-text="_T_DB(aboutUsPage, 'banner_text')"
      :banner-image="aboutUsPage.banner_image"
    />
    <content-part
      :content-heading="_T_DB(aboutUsPage, 'content_heading')"
      :content-text="_T_DB(aboutUsPage, 'content')"
      :content-image="aboutUsPage.content_image"
    />
    <values-part :blocks="aboutUsPage.extra_blocks" />
  </div>
</template>

<script>
import BannerPart from './components/BannerPart'
import ContentPart from './components/ContentPart'
import ValuesPart from './components/ValuesPart'
import { mapGetters } from 'vuex'

export default {
  name: 'StaticAboutUs',
  components: {
    BannerPart,
    ContentPart,
    ValuesPart,
  },
  computed: {
    ...mapGetters(['_T_DB', 'all_static_pages']),
    aboutUsPage() {
      if (this.all_static_pages) {
        return this.all_static_pages.find(
          page => page.type === 'regular' && page.slug === 'about'
        )
      }
      return {}
    },
  },
}
</script>

<style lang="scss">
.trending-blog {
  .blog-title {
      h2 {
          text-align: center;
          text-transform: capitalize;
          line-height: $px39;
          letter-spacing: 0.7px;
          color: $font-color;
          padding-bottom: calc(#{$px15} + (42 - 15) * ((100vw - #{$px320}) / (1920 - 320)));
          margin-bottom: calc(#{$px25} + (74 - 25) * ((100vw - #{$px320}) / (1920 - 320)));
          position: relative;
          &::after {
              position: absolute;
              content: '';
              bottom: 0;
              left: 0;
              right: 0;
              margin: 0 auto;
              width: $px90;
              height: $px5;
              background-color: $color-tertiary;
          }
      }
  }
}
</style>

